import { jsonService } from "../api/json.service";
import { alertError } from "./dialogs";
import { toShortCode } from "./format-functions";

const logoData = "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"

type Handler = (args: any) => void;

export interface UsbPrinter {
    USBName: string;
    USBPath: string;
}

export class TscCommands {
    commands: any[] = [];

    constructor(commands?: any[]) {
        this.commands = [...commands || []];
    }

    /**
     * 连接USB打印机
     * @param usbPrinter usb路径，若未传入参数，则自动连接找到的第一台打印机
     */
    openUsbPort(usbPrinter?: string) {
        this.commands.push({ "openport_usb": usbPrinter || "" });
    }

    /**
     * 连接网络打印机
     * @param ip 打印机IP地址
     * @param port 打印机网络端口
     */
    openNetPort(ip: string, port: string | number) {
        this.commands.push({ "openport_net": `${ip},${port}` });
    }

    /**
     * 中断打印机连接
     */
    closePort() {
        this.commands.push({ "closeport": "" });
    }

    /**
     * 清除打印机Buffer
     */
    clearBuffer() {
        this.commands.push({ "clearbuffer": "" });
    }

    /**
     *description	打印条码
     *@param x:			条码x轴座标(单位dot)
     *@param y:			条码y轴座标(单位dot)
     *@param type:			条码类型["128", "128M", "EAN128", "25", "25C", "39", "39C", "93", "EAN13", "EAN13+2", "EAN13+5", "EAN8", "EAN8+2", "EAN8+5", "CODA", "POST", "UPCA", "UPCA+2", "UPCA+5", "UPCE", "UPCE+2", "UPCE+5", "CPOST", "MSI", "MSIC", "PLESSEY", "ITF14", "EAN14", "11", "TELEPEN", "TELEPENN", "PLANET", "CODE49", "DPI", "DPL"]
     *@param height:		条码高度
     *@param readable:		条码可读性["0":无, "1":置左, "2":置中, "3":置右]
     *@param rotation:		条码旋转["0":无, "90":90度, "180":180度, "270":270度]
     *@param narrow:		条码窄元件宽度[详见TSPL手册BARCODE条目]
     *@param wide:			条码宽元件宽度[详见TSPL手册BARCODE条目]
     *@param code:			条码内容
     */
    barcode1(x: number, y: number, type: string, height: number, readable: number,
        rotation: number, narrow: number, wide: number, code: string) {
        if (code.charAt(0) === '@') {
            this.commands.push({ "barcode": `${x},${y},"${type}",${height},${readable},${rotation},${narrow},${wide},${code}` });
        } else {
            this.commands.push({ "barcode": `${x},${y},"${type}",${height},${readable},${rotation},${narrow},${wide},"${code}"` })
        }
    }

    barcode(setting: any, code?: string) {
        this.barcode1(setting["x"], setting["y"], setting["type"], setting["height"], setting["human_readable"],
            setting["rotation"], setting["narrow"], setting["wide"], code || setting["code"]);
    }

    /**
     *@description	打印文字
     *@param x:		文字x轴座标(单位dot)
     *@param y:		文字y轴座标(单位dot)
     *@param fonttype:	内建字型名称["0", "1", "2", "3", "4", "5", "6", "7", "8", "ROMAN.TTF"] 或 下载字型名称
     *@param rotation:	文字旋转["0":无, "90":90度, "180":180度, "270":270度]
     *@param xmul:		文字x轴放大率
     *@param ymul:		文字y轴放大率
     *@param text:		打印文字
     */
    text1(x: number, y: number, fontType: string, rotation: number, xmul: number, ymul: number, text: string) {
        if (text.charAt(0) === '@') {
            this.commands.push({ "printerfont": `${x},${y},"${fontType}",${rotation},${xmul},${ymul},${text}` });
        } else {
            this.commands.push({ "printerfont": `${x},${y},"${fontType}",${rotation},${xmul},${ymul},"${text}"` });
        }
    }

    text(setting: any, text: string) {
        this.text1(setting["x"], setting["y"], setting["size"], setting["rotation"],
            setting["x_multiplication"], setting["y_multiplication"], text || setting["text"]);
    }

    qrcode(setting: any, content: string) {
        this.sendCommandCrLf(`QRCODE ${setting["x"]},${setting["y"]},${setting["ecc"]},${setting["cell"]},` +
            `${setting["mode"]},${setting["rotation"]},${setting["model"]},${setting["mask"]},` +
            `"${content || setting["content"]}"`);
    }

    logo(setting: any) {
        this.sendCommand(`BITMAP ${setting["x"]},${setting["y"]},44,90,0,`);
        this.sendBase64Uint8Array(logoData);
        this.sendCommand("\r\n");
    }

    /**
     * 发送指令到打印机
     * @param cmd 指令
     */
    sendCommand(cmd: string) {
        this.commands.push({ "sendcommand": cmd });
    }

    /**
     * 发送指令到打印机，并加上换行符（\r\n）
     * @param cmd 指令
     */
    sendCommandCrLf(cmd: string) {
        this.commands.push({ "sendcommand_crlf": cmd });
    }

    /**
     * 打印标签
     * @param sets 份数
     * @param copies 张数
     */
    print(sets: number, copies: number) {
        this.commands.push({ "printlabel": `${sets},${copies}` });
    }

    /**
     * 下载PCX文件
     * @param filePath 档案路径
     * @param savedName 保存名称
     */
    downloadPcx(filePath: string, savedName: string) {
        this.commands.push({ "downloadpcx": `${filePath},${savedName}` });
    }

    /**
     * 跳过下一张标签
     */
    formFeed() {
        this.commands.push({ "formfeed": "" });
    }

    /**
     * 关闭backfeed功能
     */
    noBackFeed() {
        this.commands.push({ "nobackfeed": "" });
    }

    /**
     *@description	打印文字
     *@param x:				文字x轴座标(单位dot)
     *@param y:				文字y轴座标(单位dot)
     *@param fontHeight:		文字大小
     *@param rotation:			文字旋转["0":无, "90":90度, "180":180度, "270":270度]
     *@param fontStyle:		文字样式["0":无, "1":斜体, "2":粗体, "3":斜体+粗体]
     *@param fontUnderline:	文字底线["0":无, "1":底线]
     *@param faceName:		字型名称[例:"Arial"]
     *@param text:				打印文字
     */
    windowsText1(x: number, y: number, fontHeight: number, rotation: number,
        fontStyle: number, fontUnderline: number, faceName: string, text: string) {
        this.commands.push({ "windowsfont": `${x},${y},${fontHeight},${rotation},${fontStyle},${fontUnderline},${faceName},${text}` });
    }

    /**
     * 打印文字
     * @param setting 配置
     * @param text 文本
     */
    windowsText(setting: any, text: string) {
        var arr = [
            setting["x"], 
            setting["y"], 
            setting["fontHeight"], 
            setting["rotation"] || 0,
            setting["fontStyle"] || 0,
            setting["fontUnderline"] || 0,
            setting["faceName"] || "Arial",
            text || setting["text"]
        ]
        this.commands.push({ "windowsfont": arr.join(",") })
    }

    /**
     * 发送元组数据到打印机
     * @param arr 元组数据
     */
    sendBase64Uint8Array(arr: string) {
        this.commands.push({ "sendUint8Array": arr });
    }

    /**
     * 获取打印机状态
     */
    printerStatus() {
        this.commands.push({ "printerstatus": "" });
    }

    /**
     * 获取打印机名
     */
    printerName() {
        this.commands.push({ "printername": "" });
    }

    /**
     * 获取打印机序号
     */
    printerSerial() {
        this.commands.push({ "printerserial": "" });
    }

    /**
     * 自检
     */
    selfTest() {
        this.sendCommandCrLf("SELFTEST");
    }
}

class TscPrinterDriver {
    url: string = "ws://127.0.0.1:8888";
    continueOnError = false;

    async getUsbPrinters(): Promise<UsbPrinter[]> {
        return await this.sendDataAsync({ "usb_list": [] });
    }

    async about() {
        return await this.sendDataAsync({ "about": [] });
    }

    async sendCommands(commands: TscCommands) {
        return await this.sendDataAsync({ "functions_inorder": commands.commands });
    }

    private sendDataAsync(obj: any) {
        let _resolve: Handler | undefined;

        this.sendData(obj, function (args: any) {
            _resolve && _resolve(args);
        });

        return new Promise((resolve: Handler) => {
            _resolve = resolve;
        })
    }

    private sendData(obj: any, callback: Handler) {
        const socket = new WebSocket(this.url);

        socket.onopen = function () {
            socket.send(JSON.stringify(obj));
        }

        socket.onmessage = function (event: MessageEvent) {
            if (event.data === "Finished") {
                socket.close();
                callback(undefined);
            } else {
                try {
                    const result = JSON.parse(event.data);
                    if ('usb_list' in result) {
                        callback(result.usb_list);
                    } else if ('printerstatus' in result) {
                        callback(result.printerstatus);
                    } else if ('printername' in result) {
                        callback(result.printername);
                    } else if ('printerserial' in result) {
                        callback(result.printerserial);
                    } else if ('about' in result) {
                        callback(result.about);
                    } else if ('Function_Failed' in result) {
                        alertError(`${result.Function_Failed}`);
                        console.log(result.Function_Failed);
                    }
                }
                catch (e: any) {
                    alertError(`${e.message || e}`);
                    console.log(e);
                }
            }
        }

        socket.onerror = (event) => {
            console.log(event);

            if (this.continueOnError) {
                callback(null);
            } else {
                alertError('无法连接打印服务，请确认TSC PrintServer是否已开启');
            }         
        }
    }
}

export const tscPrinter = new TscPrinterDriver();

export class CodePrintService {
    printer: UsbPrinter;
    setting: any = {};
    prepareCommands: any[] = [];

    constructor(printer: UsbPrinter) {
        this.printer = printer;
    }

    async prepare() {
        const setting = await jsonService.getPrintSetting(this.printer.USBName.toLowerCase());
        this.setting = setting;

        let commands = new TscCommands();
        commands.openUsbPort(this.printer.USBPath);

        if (setting["settings"]) {
            for (const cmd of setting["settings"]) {
                commands.sendCommandCrLf(cmd);
            }
        }

        this.prepareCommands = commands.commands;
    }

    print(code: string, copies?: number) {
        let _resolve: Handler | undefined;

        const printFunc = () => {
            const commands = new TscCommands(this.prepareCommands);
            commands.clearBuffer();

            commands.qrcode(this.setting["qrcode"], `Ahttps://wxm.xmjs.com.cn:8090/bottle/${toShortCode(code)}`);
            commands.logo(this.setting["logo"]);

            commands.barcode(this.setting["barcode"], code);
            commands.text(this.setting["barcodeText"], code);
            commands.print(1, copies || 2);
            commands.closePort();

            console.log(commands);

            tscPrinter.sendCommands(commands).then(() => _resolve && _resolve(undefined));
        };

        const checkAndPrint = () => {
            const commands = new TscCommands();
            commands.openUsbPort(this.printer.USBPath);
            commands.printerStatus();
            commands.closePort();
            tscPrinter.sendCommands(commands).then((status: any) => {
                if (["Ready", "Printing"].indexOf(status instanceof Array ? status[0] : status) !== -1) {
                    printFunc();
                } else if (tscPrinter.continueOnError) {
                    printFunc();
                } else {
                    console.log(status);
                    alertError("打印机状态异常，请处理完成并看到绿灯后再点击确定继续").then(checkAndPrint);
                }
            })
        }

        setTimeout(checkAndPrint, this.setting["delay"] * (copies || 2));

        return new Promise((resolve) => {
            _resolve = resolve;
        });
    }
}

export class SecurityCodePrintService {
    printer: UsbPrinter;
    setting: any = {};
    prepareCommands: any[] = [];

    constructor(printer: UsbPrinter) {
        this.printer = printer;
    }

    async prepare() {
        const setting = await jsonService.getPrintSetting(
            `security_${this.printer.USBName.toLowerCase()}`);

        this.setting = setting;

        let commands = new TscCommands();
        commands.openUsbPort(this.printer.USBPath);

        if (setting["settings"]) {
            for (const cmd of setting["settings"]) {
                commands.sendCommandCrLf(cmd);
            }
        }

        this.prepareCommands = commands.commands;
    }

    print(gasCode: string, copies?: number) {
        let _resolve: Handler | undefined;

        let textSetting = this.setting["wintext"];
        if (gasCode.length > 6) {
            textSetting = JSON.parse(JSON.stringify(textSetting));
            textSetting.x -= textSetting["numberX"] * (gasCode.length - 6);
        }

        const printFunc = () => {
            const commands = new TscCommands(this.prepareCommands);
            commands.clearBuffer();

            commands.qrcode(this.setting["qrcode"], `Ahttps://wxm.xmjs.com.cn:8090/customer/securityinfo/${gasCode}`);
            commands.windowsText(textSetting, `购气卡号：${gasCode}`);
            commands.print(1, copies || 1);
            commands.closePort();

            console.log(commands);

            tscPrinter.sendCommands(commands).then(() => _resolve && _resolve(undefined));
        };

        const checkAndPrint = () => {
            const commands = new TscCommands();
            commands.openUsbPort(this.printer.USBPath);
            commands.printerStatus();
            commands.closePort();
            tscPrinter.sendCommands(commands).then((status: any) => {
                if (["Ready", "Printing"].indexOf(status instanceof Array ? status[0] : status) !== -1) {
                    printFunc();
                } else if (tscPrinter.continueOnError) {
                    printFunc();
                } else {
                    console.log(status);
                    alertError("打印机状态异常，请处理完成并看到绿灯后再点击确定继续").then(checkAndPrint);
                }
            })
        }

        setTimeout(checkAndPrint, this.setting["delay"] * (copies || 1));

        return new Promise((resolve) => {
            _resolve = resolve;
        });
    }
}